import axios from 'axios';
// 
// export const ApiUrl = "http://127.0.0.1:8000/api";
export const ApiUrl = "https://cms.mmimissionaryworld.org/api";
export const ReligioUrl = "https://app.mmimissionaryworld.org/api";

const memoryCache = new Map();
const inFlightRequests = new Map();
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export const fetchWithCache = async (
  url,
  stateSetter,
  cacheKey,
  loadingSetter = () => { },
  selector = (resData) => resData?.data || resData,
  forceRefresh = false
) => {
  const now = Date.now();

  // 1. In-memory cache hit - instant return < 1ms
  if (!forceRefresh && memoryCache.has(cacheKey)) {
    const entry = memoryCache.get(cacheKey);
    if (now - entry.timestamp < CACHE_TTL_MS) {
      stateSetter(entry.data);
      loadingSetter(false);
      return entry.data;
    }
  }

  // 2. localStorage hit - instant UI populate
  let cachedData = null;
  let savedTime = 0;
  const localStorageItem = localStorage.getItem(cacheKey);
  if (localStorageItem) {
    try {
      const parsed = JSON.parse(localStorageItem);
      if (parsed !== null && parsed !== undefined) {
        if (parsed && typeof parsed === 'object' && 'data' in parsed && 'timestamp' in parsed) {
          cachedData = parsed.data;
          savedTime = parsed.timestamp;
        } else {
          cachedData = parsed;
        }

        if (cachedData !== undefined && cachedData !== null) {
          stateSetter(cachedData);
          loadingSetter(false);

          if (!forceRefresh && savedTime && (now - savedTime < CACHE_TTL_MS)) {
            memoryCache.set(cacheKey, { data: cachedData, timestamp: savedTime });
            return cachedData;
          }
        }
      }
    } catch (e) {
      console.error("Cache parse error for key:", cacheKey, e);
    }
  }

  // 3. Request deduplication - reuse active promise if in-flight
  if (inFlightRequests.has(url)) {
    try {
      const data = await inFlightRequests.get(url);
      if (data !== undefined && data !== null) {
        stateSetter(data);
      }
      return data;
    } catch (err) {
      console.error("In-flight request error for url:", url, err);
    } finally {
      loadingSetter(false);
    }
  }

  // 4. Perform network fetch & update caches
  const requestPromise = (async () => {
    try {
      const response = await axios.get(url);
      const mappedData = selector(response?.data);
      if (mappedData !== undefined && mappedData !== null) {
        const cacheEntry = { data: mappedData, timestamp: Date.now() };
        memoryCache.set(cacheKey, cacheEntry);
        try {
          localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
        } catch (e) {
          // Quota safeguard
        }
        stateSetter(mappedData);
        return mappedData;
      }
    } catch (err) {
      console.error("API fetch error for url:", url, err);
      throw err;
    } finally {
      inFlightRequests.delete(url);
      loadingSetter(false);
    }
  })();

  inFlightRequests.set(url, requestPromise);
  return requestPromise;
};
